import type { InvoiceInput } from '@/modules/billing/types';

export function validateInvoiceInput(input: InvoiceInput): string | null {
  if (!input.issueDate) return 'La fecha de emisión es obligatoria.';
  if (input.subtotal < 0 || input.taxes < 0 || input.total < 0) {
    return 'Los importes no pueden ser negativos.';
  }
  if (input.total <= 0 && input.status !== 'draft') {
    return 'El total debe ser mayor a cero para emitir.';
  }
  if (input.type === 'fiscal') {
    return 'Factura fiscal no disponible hasta integración ARCA (Worker).';
  }
  return null;
}
